var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"export-card",on:{"click":function($event){return _vm.downloadImage()}}},[_c('span',{staticClass:"export-card-image"},[_c('font-awesome-icon',{attrs:{"icon":[_vm.iconWeight, _vm.icon]}})],1),_c('span',{staticClass:"export-card-type"},[_vm._v(_vm._s(_vm.cardText))])])
}
var staticRenderFns = []

export { render, staticRenderFns }